<!--

 -->

<template>
  <reports-table
    module="pim"
    name="pim_defined"
    :prefetch="true"
    :filters="filters"
  >
    <div class="gsl-hrm-card-container flex-container">
      <oxd-text tag="h6" class="gsl-hrm-main-title">
        {{ reportName }}
      </oxd-text>
      <report-download-csv
        name="pim_defined"
        module="pim"
        :prefetch="true"
        :filters="filters"
      />
    </div>
    <br />
  </reports-table>
</template>

<script>
import {ref} from 'vue';
import ReportsTable from '@/core/components/table/ReportsTable';
import ReportCSVDownload from '@/core/components/table/ReportCSVDownload.vue';

export default {
  components: {
    'report-download-csv': ReportCSVDownload,
    'reports-table': ReportsTable,
  },
  props: {
    reportId: {
      type: String,
      required: true,
    },
    reportName: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const filters = ref({
      reportId: props.reportId,
    });

    return {
      filters,
    };
  },
};
</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  justify-content: space-between;
  padding: 10px 25px;
  ::v-deep(.oxd-button--text) {
    width: 109px;
    padding: 6px 0;
  }
}
</style>
